import { useMemo } from "react";
import { useLocation } from "react-router";
import qs from 'querystring'

export const useQuery = (): object => {
    const { search } = useLocation();
    return useMemo(() => qs.parse(search.startsWith('?') ? search.slice(1) : search), [search]);
}